import React, { FC } from "react";
import { GridTable } from "..";
import {
  ActionTypeEnum,
  PageEnum,
  RequestActionModel,
  SearchRuleExpenseMoneyRequestModel,
} from "../../models";

import { isArabicCurrentLanguage } from "../../utils";
export const RuleExpenseMoneyList: FC<{
  acTransactionSearch: SearchRuleExpenseMoneyRequestModel[];
  totalRows: number;
  searchParams: SearchRuleExpenseMoneyRequestModel;
  defaultPageSize: number;
  onCurrentPageChange: Function;
  onPageSizeChange: Function;
  setShowAcTransactionModel: Function;
  setAcTransaction: Function;
  setShowDeleteModel: Function;
  loading: boolean;
  setShowPrintModel: Function;
  setLoading: Function;
  setIsFormLoading: React.Dispatch<React.SetStateAction<boolean>>;
  formID: PageEnum;
  onActionEvent: (request: RequestActionModel) => Promise<void>;
}> = (props) => {
  //#region variables
  const {
    acTransactionSearch,
    totalRows,
    searchParams,
    defaultPageSize,
    onCurrentPageChange,
    onPageSizeChange,
    onActionEvent,
    loading,
    formID,
  } = props;
  //#endregion
  //#region html
  return (
    <>
      <GridTable
        // columns={columns}
        data={acTransactionSearch}
        totalRows={totalRows}
        externalLoading={loading}
        currentPage={searchParams.pageNumber || 1}
        pageSize={searchParams.pageSize || defaultPageSize}
        onCurrentPageChange={onCurrentPageChange}
        onPageSizeChange={onPageSizeChange}
        paginationType="server"
        columnsProps={{
          actions: [ActionTypeEnum.Update, ActionTypeEnum.Delete],
          isArabic: isArabicCurrentLanguage(),
          onActionEvent,
        }}
        formId={formID}
      />
    </>
  );
  //#endregion
};
